<template>
  <div id="navigation" class="navbar navbar-expand-sm navbar-fixed-top container-fluid"
       :style="{ top: top + 'px', position: position }">
    <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbar-collapse-item"
            aria-controls="navbar-collapse-item" aria-expanded="false" aria-label="Toggle navigation">
      <span>Gents of Jazz</span><span class="logo"><img src="../../../assets//goj_bildmarke_weiss.svg" style="height: 30px"/> Menü</span>
    </button>
    <div class="collapse navbar-collapse" id="navbar-collapse-item">
      <div class="container-fluid">
        <ul class="nav navbar-nav">
          <li>
            <a href="#" v-scroll-to="'#videoFrame'">
              Home
            </a>
          </li>
          <li>
            <a href="#" v-scroll-to="'#about'">
              About
            </a>
          </li>
          <li class="logo">
            <a class="logo">
              <img src="../../../assets/goj_bildmarke_weiss.svg" style="height: 50px"/>
            </a>
          </li>
          <li>
            <a href="#" v-scroll-to="'#media'">
              Media
            </a>
          </li>
          <li>
            <a href="#" v-scroll-to="'#contact'">
              Contact
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      sticky: 0,
      top: 0,
      position: 'fixed'
    }
  },
  mounted () {
    if (window.innerWidth > 540) {
      this.sticky = window.innerHeight - 110
      this.top = this.sticky
      this.position = 'absolute'
    }
  },
  methods: {
    handleScroll () {
      if (window.pageYOffset >= this.sticky) {
        this.top = 0
        this.position = 'fixed'
      } else {
        this.top = this.sticky
        this.position = 'absolute'
      }
    }
  },
  created () {
    if (window.innerWidth > 540) {
      window.addEventListener('scroll', this.handleScroll)
    }
  },
  destroyed () {
    if (window.innerWidth > 540) {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
}
</script>

<style lang="scss" scoped>
  #navigation {
    background-color: #0d0d0d;
    padding: 1em 0;
    position: absolute;
    z-index: 10;

    > button {
      background: none;
      border: none;
      width: 100%;

      @media all and (min-width: 540px) {
        display: none;
      }

      > span {
        font-family: "catamaranbold";
        text-transform: uppercase;
        letter-spacing: 3px;
        color: white;
        padding-left: 15px;
        float: left;

        &.logo {
          float: right;
          padding-right: 15px;
        }

      }
    }

    #navbar-collapse-item {

      .container-fluid {
        display: table;
        width: inherit;

        ul > li {

          &.logo {
            margin: 15px;
          }

          > a {

            &:hover {
              background-color: transparent;
              text-decoration: none;
            }

            &:not(.logo) {
              font-family: "catamaranbold";
              text-transform: uppercase;
              letter-spacing: 3px;
              font-size: 110%;
              color: white;
              line-height: 80px;
              margin: 0 15px;
              cursor: pointer;

              &:hover {
                border-bottom: 3px solid white;
              }

            }
          }
        }

        @media all and (max-width: 540px) {
          margin: 0 15px;

          ul > li {
            display: inline-block;
            width: 40%;

            &.logo {
              display: none;
            }
          }

        }
      }
    }

    .navbar-toggler:focus {
      outline: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/Navigation/Navigation.vue